/**
 * Mailing settings — the SMTP relay and the send throttle.
 *
 * The password comes back masked and the mask is sent straight back when the
 * user doesn't retype it; the backend treats that value as "unchanged", so an
 * unrelated edit can never blank the stored secret.
 */
define('mailingSettingsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  App,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var SettingsView = Marionette.ItemView.extend({

    className: 'mailing-page mailing-settings',

    template: _.template(
      '<%= nav %>' +
      '<div class="mlg-body"><div class="mlg-loading">Loading settings…</div></div>'
    ),

    ui: {
      body: '.mlg-body'
    },

    events: {
      'click .mlg-save-settings': 'onSave',
      'click .mlg-test-smtp': 'onTest'
    },

    serializeData: function () {
      return {
        nav: Shell.navHtml('settings',
          '<button type="button" class="mlg-btn mlg-test-smtp">Test connection</button>' +
          '<button type="button" class="mlg-btn primary mlg-save-settings">Save</button>')
      };
    },

    onShow: function () {
      this.load();
    },

    load: function () {
      var self = this;
      MailingApi.settings().done(function (settings) {
        self.renderForm(settings || {});
      }).fail(function (xhr) {
        self.ui.body.html('<div class="mlg-error">' + _.escape(MailingApi.errorMessage(xhr)) + '</div>');
      });
    },

    renderForm: function (settings) {
      var secure = settings.smtpSecure !== 'false';
      this.ui.body.html(
        '<div class="mlg-settings-card">' +
        '<h3>SMTP relay</h3>' +
        '<div class="mlg-row">' +
        '  <label class="grow">Host<input type="text" class="f-host" value="' +
             _.escape(settings.smtpHost || '') + '"></label>' +
        '  <label class="narrow">Port<input type="number" class="f-port" value="' +
             _.escape(settings.smtpPort || '587') + '"></label>' +
        '</div>' +
        '<div class="mlg-row">' +
        '  <label class="grow">Username<input type="text" class="f-user" value="' +
             _.escape(settings.smtpUser || '') + '"></label>' +
        '  <label class="grow">Password<input type="password" class="f-password" value="' +
             _.escape(settings.smtpPassword || '') + '"></label>' +
        '</div>' +
        '<div class="mlg-row">' +
        '  <label class="grow">Sender name<input type="text" class="f-from-name" value="' +
             _.escape(settings.smtpFromName || '') + '"></label>' +
        '  <label class="check"><input type="checkbox" class="f-secure"' + (secure ? ' checked' : '') +
             '> Use STARTTLS</label>' +
        '</div>' +
        '<div class="mlg-hint">The password is stored encrypted and never sent back to this screen. ' +
          'Leave the dots untouched to keep the current one.</div>' +
        '</div>' +

        '<div class="mlg-settings-card">' +
        '<h3>Sending rate</h3>' +
        '<div class="mlg-row">' +
        '  <label class="narrow">Max per hour<input type="number" min="1" class="f-max-per-hour" value="' +
             _.escape(settings.queueMaxPerHour || '100') + '"></label>' +
        '  <label class="narrow">Seconds between sends<input type="number" min="0" step="0.5" ' +
             'class="f-delay" value="' + _.escape(settings.queueDelaySeconds || '2') + '"></label>' +
        '</div>' +
        '<div class="mlg-hint">The outbox is drained once a minute, at most 20 emails per pass, ' +
          'never exceeding the hourly limit. Both guards protect the relay\'s reputation.</div>' +
        '</div>');
    },

    onSave: function () {
      var self = this;
      var $body = this.ui.body;
      MailingApi.updateSettings({
        smtpHost: $body.find('.f-host').val(),
        smtpPort: $body.find('.f-port').val(),
        smtpUser: $body.find('.f-user').val(),
        smtpPassword: $body.find('.f-password').val(),
        smtpFromName: $body.find('.f-from-name').val(),
        smtpSecure: $body.find('.f-secure').is(':checked') ? 'true' : 'false',
        queueMaxPerHour: $body.find('.f-max-per-hour').val(),
        queueDelaySeconds: $body.find('.f-delay').val()
      }).done(function (settings) {
        Shell.banner(self.$el, 'Settings saved', 'ok');
        self.renderForm(settings || {});
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    /** Tests the *stored* credentials, so save before testing a change. */
    onTest: function () {
      var self = this;
      MailingApi.testSmtp().done(function (result) {
        Shell.banner(self.$el, result.message || 'SMTP connection successful', 'ok');
      }).fail(function (xhr) {
        var body = xhr.responseJSON || {};
        Shell.banner(self.$el, body.error || MailingApi.errorMessage(xhr), 'error');
      });
    }
  });

  module.exports = SettingsView;
});

